import axios from 'axios'
import {AuthModel, UserModel, ResponseModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/Auth/get-user-by-token`
export const GET_TOKEN_URL = `${API_URL}/Auth/get-token`
export const LOGIN_URL = `${API_URL}/Auth/login`
export const REGISTER_URL = `${API_URL}/Auth/register`
export const APPROVE_URL = `${API_URL}/Auth/approve`
export const RESET_URL = `${API_URL}/Auth/reset`
export const REQUEST_PASSWORD_URL = `${API_URL}/Auth/forgot_password`
export const AYDINLATMA_METNI_URL = `${API_URL}/Custom/getAydinlatmaMetni?typeId=4`
export const REGISTER_DATES_URL = `${API_URL}/Custom/GetRegisterDates`
export const ResendCode_URL = `${API_URL}/Auth/ResendCode`

// Server should return AuthModel

export function login(userName: string, password: string, recaptchaToken: string) {
  return axios.post<ResponseModel>(LOGIN_URL, {
    userName,
    password,
    recaptchaToken,
  })
}
//get-token///////////////////
export function getToken(userName: string, verificationCode: string) {
  return axios.post<AuthModel>(GET_TOKEN_URL, {
    userName,
    //password
    verificationCode,
  })
}
///////////
export function resendVerificationCode(userName: string) {
  return axios.post<ResponseModel>(ResendCode_URL, {
    userName,
    //password
  })
}

// Server should return AuthModel
export function register(email: string, firstname: string, lastname: string, password: string) {
  return axios.put(REGISTER_URL, {
    email,
    name: firstname,
    surname: lastname,
    password,
  })
}

// Server should return ok
export function approve(approveGuid: string) {
  return axios.post(`${APPROVE_URL}?guid=${approveGuid}`)
}
// Server should return ok
export function resetpassword(guid: string, password: string) {
  return axios.post(`${RESET_URL}?guid=${guid}&password=${password}`)
}
// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(`${REQUEST_PASSWORD_URL}?email=${email}`)
}

export function getUserByToken() {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL)
}

export function getAydinlatmaMetni() {
  return axios.get<any>(AYDINLATMA_METNI_URL)
}

export function getRegisterDates() {
  return axios.get<any>(REGISTER_DATES_URL)
}
